export class HelperGHeader {
  constructor() {
    this.gHeader = document.querySelector(".gHeader");
  }
}
